<template>
    <div class="foot-all">
        <div class="foot-all-up">
            <div class="footer-left">
                <ul class="left-ul">
                    <li class="left-1">
                        <div>
                            <h3><a href="https://newsuit.com.tw/">鋅 宏 西 服</a></h3>
                            <h3><a href="https://newpolo.com.tw/">鋅 宏 製 衣 廠</a></h3>
                            <h3><a href="https://newcap.com.tw/">鋅 宏 製 帽 廠</a></h3>
                            <h3><a href="http://satchel.soqimage.com.tw/">書 包 集 中 站</a></h3>
                        </div>
                    </li>
                    <li class="left-1">
                        <div>
                            <h3><a href="#">品 牌 故 事</a></h3>
                            <h3><a href="#">認 識 團  隊</a></h3>
                            <h3><a href="#">常 見 問 題</a></h3>
                            <h3><a href="#">最 新 消 息</a></h3>
                        </div>
                    </li>
                    <li class="left-1">
                        <div>
                            <h3><a href="#">常 見 問 題</a></h3>
                            <h3><a href="#/">訂 購 流 程</a></h3>

                        </div>
                    </li>
                    <li class="left-1">
                        <div>
                            <h3><a href="tel:0229926999">客服：02-29926999</a></h3>
                            <h3><a href="tel:0289937781">專線：02-89937781</a></h3>
                            <h3><a href="tel:0289937880">傳真：02-89937880</a></h3>
                        </div>
                    </li>
                    <li class="left-1">
                        <div>
                            <h3><a href="tel:0938393011">台北：0938-393-011</a></h3>
                            <h3><a href="tel:0938316568">桃竹苗：0938-316-568</a></h3>
                            <h3><a href="tel:0909593777">台中：0909-593-777</a></h3>
                            <h3><a href="tel:0938616686">高雄：0938-393-011</a></h3>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="footer-right">
                <img src="~@/assets/img/logo-big.png" alt="logo-icon">
                <h3><a href="mailto:mypolo@soqimage.net">合 作 / mypolo@soqimage.net</a></h3>
                <h3><a href="tel:0229926999">專 線 / 02-29926999</a></h3>
                <ul>
                    <li class="footer-icon">
                        <a href="tel:0909853777" target="_blank">
                            <i class="el-icon-phone-outline"></i>
                        </a>
                        <a href="https://line.me/R/ti/p/%40962ktrrr" target="_blank">
                            <i class="el-icon-chat-dot-square"></i>
                        </a>
                        <a href="https://www.facebook.com/newred01/?ref=aymt_homepage_panel&eid=ARDErxOxRpXZmdovY--teizCdSQc0AOWMVqZhMqzYD9A6Z0dcJYPS9HU6iwxpR5DDDYNf-d-dlHbMPJR" target="_blank">
                            <i class="fab fa-facebook-square"></i>
                        </a>
                        <a href="https://www.instagram.com/" target="_blank">
                            <i class="fab fa-instagram"></i>
                        </a>
                        <a href="https://www.youtube.com/channel/UC0-XrnulpzVbCn-BHwdJt1g/" target="_blank">
                            <i class="fab fa-youtube"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="foot-all-down">
            <p>Copyright 2020 © Copyright NEWRED Co. Ltd.    |    All Rights Reserved Development by william -
                <a href="https://treefonts.com/" style="color: #5e5e5e;">Web Design</a>
            </p>
        </div>
    </div>

</template>

<script>

  export default {
    name: 'footerEnd'
  };

</script>
<style lang='scss' scoped>
    .foot-all-up {
        width: 60%;
        margin: 0 auto;
        padding: 40px 0;
        display: flex;
        justify-content: space-between;
        .footer-left {
            .left-ul {
                display: flex;
                .left-1 {
                    margin-right: 2vw;
                    h3 {
                        margin-bottom: 20px;
                        font-size: 0.9rem;
                        border-bottom: 2px solid transparent;
                        transition: .3s;
                        &:hover {
                            border-bottom: 2px solid #00a9e0;
                        }
                    }

                }
            }
        }
        .footer-right {
            img {
                width: 250px;
                margin-bottom: 10px;
            }
            h3 {
                margin-bottom: 10px;
                font-size: 0.9rem;
            }
            ul {
                .footer-icon {
                    font-size: 1.2rem;
                }
            }
        }
    }
    .foot-all-down {
        text-align: center;
        background-color: rgb(248, 248, 248);
        padding: 30px 0;
    }
    @media screen and (min-width: 1920px){}
    @media (min-width:1366px) and (max-width:1920px){
        .foot-all-up {
            width: 80%;
        }
    }
    @media (min-width:1024px) and (max-width:1365px){
        .foot-all-up {
            width: 90%;
        }
    }
    @media (min-width:768px) and (max-width:1023px){}
    @media screen and (max-width: 767px){
        .footer-left {
            display: none;
        }
        .foot-all-up {
            .footer-right {
                ul {
                    .footer-icon {
                        font-size: 2rem;
                    }
                }
            }
        }

    }

    // @media screen and (min-width: 1920px){}
    // @media (min-width:1366px) and (max-width:1920px){}
    // @media (min-width:1024px) and (max-width:1365px){}
    // @media (min-width:768px) and (max-width:1023px){}
    // @media (min-width:414px) and (max-width:767px){}
    // @media (min-width:374px) and (max-width:413px){}
    // @media screen and (max-width: 373px){}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue